/**
 * The job number a clock-in shift was worked on, for display: "EWJ-0001", or a
 * casing job's "J-4329".
 *
 * `job_number` is the number snapshotted on the shift when it was clocked in on
 * a work item (earthworks and the other work-item verticals). A casing shift
 * stores only `job_id`, so its number comes from the job: the API resolves that
 * as `display_job_number` (`COALESCE(t.job_number, jobs.job_number)`) and this
 * prefers it. Absent on both → null, and the caller shows nothing — a shift
 * with no job is a shop shift or a pre-job one, not a shift on job "—".
 */
export function shiftJobNumber(ts: {
  display_job_number?: string | null;
  job_number?: string | null;
}): string | null {
  for (const v of [ts.display_job_number, ts.job_number]) {
    if (typeof v === 'string' && v.trim() !== '') return v.trim();
  }
  return null;
}
